import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "../../../../api/client";
import { GlobalContext } from "../../../../context";
import Icon from "../Icon";
import { Pill } from "./staffUi";

const day = (ymd) => (ymd ? new Date(`${ymd}T12:00:00Z`).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" }) : "");
export const planName = (p) => (p.cohort.startsWith(p.course) ? p.cohort : `${p.course} · ${p.cohort}`);
export const planUrl = (p) => `/dashboard/staff/plans/${p.cohort_id}/${p.course_id}`;

/** Admin "Course plans" / instructor "My classes": every cohort-course and where its plan is at. */
export default function StaffPlansPage() {
  const { authState: { data: auth } } = useContext(GlobalContext);
  const isAdmin = !!auth?.user?.is_admin;
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    client.get("/staff/plans").then((r) => setRows(r.data.plans)).catch(() => setError(true));
  }, []);

  return (
    <div className="lms"><div className="main single" style={{ maxWidth: 1240 }}><div className="view">
      <div className="sp-top">
        <div><span className="sp-kicker">{isAdmin ? "Learning" : "Teach"}</span><h1>{isAdmin ? "Course plans" : "My classes"}</h1>
          <p>Each course in a cohort runs on a plan of weeks. Classes, materials, quizzes and the capstone live inside the weeks.</p></div>
      </div>
      {error ? <section className="complete-box"><div><strong>We couldn't load the plans</strong><small>Refresh the page to try again.</small></div></section>
        : !rows ? <div className="skeleton" style={{ height: 300 }} />
        : !rows.length ? <section className="complete-box"><div><strong>No courses yet</strong><small>{isAdmin ? "Add courses to a cohort first." : "Your courses appear here once you're assigned to one."}</small></div></section>
        : (
          <section className="sp-box">
            <div className="sp-table-wrap"><table className="sp-table">
              <thead><tr><th>Course · cohort</th><th>Instructor</th><th>Weeks</th><th>Now</th><th className="num">Students</th><th /></tr></thead>
              <tbody>{rows.map((p) => (
                <tr key={`${p.cohort_id}-${p.course_id}`}>
                  <td><strong style={{ color: "var(--ink)", fontWeight: 500 }}>{p.course}</strong><div className="course-tag" style={{ fontSize: 12.5 }}>{p.cohort}</div></td>
                  <td>{p.instructors.length ? p.instructors.join(", ") : <span className="course-tag">Not assigned</span>}</td>
                  <td>{p.weeks ? <>{p.weeks} weeks<div className="course-tag" style={{ fontSize: 12.5 }}>{day(p.starts_on)} – {day(p.ends_on)}</div></> : <span className="course-tag">{p.classes ? `No plan yet · ${p.classes} classes scheduled` : "No plan yet"}</span>}</td>
                  <td>{p.current ? <Pill cls="brand">{p.current}</Pill> : p.finished ? <Pill cls="ok">Finished</Pill> : p.weeks ? <Pill cls="gray">Not started</Pill> : "—"}</td>
                  <td className="num">{p.students}</td>
                  <td className="num"><Link className={`cbtn ${p.weeks ? "quiet" : "go"}`} to={planUrl(p)}>{p.weeks ? "Open plan" : isAdmin ? "Create plan" : "View"}</Link></td>
                </tr>
              ))}</tbody>
            </table></div>
            {!isAdmin && <div className="sp-foot"><span>Need to add a makeup class or post materials the old way? <Link className="link-btn" to="/dashboard/instructor/courses">Open the classic classroom view</Link></span></div>}
          </section>
        )}
      <p className="course-tag" style={{ display: "flex", gap: 6, alignItems: "center" }}><Icon name="info" size={14} />Times are planned in WAT. A class belongs to the week its date falls in, so moving a week moves its classes.</p>
    </div></div></div>
  );
}
